var localeValues = {
  locale: 'zh-CN',
  Dialog: {
    okText: '确定',
    cancelText: '取消'
  },
  Toast: {
    cancelText: '取消'
  },
  Search: {
    actionText: '搜索'
  }
};

export { localeValues as default };
//# sourceMappingURL=zh-CN.js.map
